import { useEffect } from 'react';
import { useNavigation, Screen } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';
import AccountBiometricLogin from '../components/AccountBiometricLogin/AccountBiometricLogin';

function AccountBiometricLoginScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('biometricLoginTitle') });
  }, [navigation, t]);

  return (
    <Screen>
      <AccountBiometricLogin />
    </Screen>
  );
}

export default AccountBiometricLoginScreen;
